import Vue from 'vue'

Vue.filter('roundNumber', function (value, places = 3) {
  return parseFloat(value).toFixed(places)
})



// WEBPACK FOOTER //
// ./src/filters/roundNumber.js